module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0072.jpg?v=1031dab8";